import Api from "@/services/endpoint/tenant.service.js";

export const can = async (permissionName) => {
  const response = await Api.Permission.postHasPermission(
    permissionName
  );
  return response.data.status;
};


// WEBPACK FOOTER //
// ./src/common/tenancy/permission.utils.js